var EAffiliateCurrency = /*#__PURE__*/ function(EAffiliateCurrency) {
    EAffiliateCurrency["EUR"] = "EUR";
    EAffiliateCurrency["GBP"] = "GBP";
    EAffiliateCurrency["USD"] = "USD";
    return EAffiliateCurrency;
}(EAffiliateCurrency || {});
export { EAffiliateCurrency };
